import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDotGrid1x3VerticalTight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"dot-grid-1x3-vertical-tight, menu, drag, grab"} maskId="square-filled-radius-0-stroke-1-IconDotGrid1x3VerticalTight"><rect x="10" y="3" width="4" height="4" fill="currentColor"/><rect x="10" y="10" width="4" height="4" fill="currentColor"/><rect x="10" y="17" width="4" height="4" fill="currentColor"/></CentralIconBase>;
}));

export default IconDotGrid1x3VerticalTight;
